import { Alert, Container, Typography } from "@mui/material";

function EmptyResult({ principal, secundaria }) {
  return (
    <Container sx={{ marginTop: 2 }}>
      <Alert variant="outlined" severity="info">
        <Typography></Typography>
        <h2>
          <b>{principal}</b>
        </h2>
        {secundaria}
      </Alert>
    </Container>
  );
}

export { EmptyResult };
